<!--  -->
<template>
  <div class="i-swiper">
    <el-carousel
      ref="carousel"
      height="640px"
      :autoplay="false"
      indicator-position="none"
    >
      <el-carousel-item v-for="item in imgList" :key="item">
        <el-image
          class="el-carousel-img"
          :src="item"
          fit="cover"
          :preview-src-list="imgList"
        ></el-image>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    imgList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      initialIndex: 0,
    };
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.i-swiper {
  width: 100%;
  .el-carousel-img {
    width: 100%;
    height: 640px;
  }
}
</style>
